module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 3-82471b0edfd4263a1a6fb393ecfea629.jpg";